var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    fill: "white",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 14C5.49333 14 3 11.5067 3 8.5C3 5.49333 5.49333 3 8.5 3C11.5067 3 14 5.49333 14 8.5C14 11.5067 11.5067 14 8.5 14ZM13.0467 8.5C13.0467 5.93333 10.9933 3.95333 8.42667 3.95333C5.93333 3.95333 3.95333 6.00667 3.95333 8.5C3.95333 11.0667 6.00667 13.12 8.57333 13.12C11.0667 13.0467 13.12 10.9933 13.0467 8.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.93991 8.06004C9.74657 8.06004 10.4799 8.06004 11.2132 8.06004C11.2132 8.35337 11.2132 8.64671 11.2132 8.94004C10.1866 8.94004 9.08657 8.94004 7.98657 8.94004C7.98657 7.54671 7.98657 6.22671 7.98657 4.83337C8.27991 4.83337 8.57324 4.83337 8.86657 4.83337C8.93991 5.93337 8.93991 6.96004 8.93991 8.06004Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.a9c2af21a63dd01d0cb08af0eac4f41d.svg";
export { ForwardRef as ReactComponent };